import React, { useState } from 'react';
import { apiClient } from '../api/client';
import './GoogleSignInButton.css';

interface GoogleSignInButtonProps {
  mode: 'signin' | 'link'; // Вход или привязка
  onStart?: () => void;
  onError?: (error: string) => void;
}

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({ 
  mode, 
  onStart,
  onError 
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    // Предотвращаем множественные клики
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);
      onStart?.();
      
      // Добавляем таймаут для запроса (30 секунд)
      const timeoutPromise = new Promise<never>((_, reject) => {
        setTimeout(() => reject(new Error('Превышено время ожидания ответа от сервера')), 30000);
      });

      const authPromise = apiClient.initiateGoogleAuth(mode === 'link');
      const { auth_url } = await Promise.race([authPromise, timeoutPromise]);
      
      if (!auth_url) {
        throw new Error('Не получен URL для авторизации');
      }

      console.log('✅ Google OAuth URL получен:', auth_url);
      
      // Проверяем, работаем ли мы в Telegram WebApp
      if (window.Telegram?.WebApp) {
        // Открываем в системном браузере (обходит disallowed_useragent)
        window.Telegram.WebApp.openLink(auth_url);
        console.log('🔗 Google OAuth открыт в системном браузере через Telegram API');
        // Сбрасываем состояние после небольшой задержки, чтобы дать время на открытие ссылки
        setTimeout(() => setIsLoading(false), 500);
      } else {
        // Fallback для обычного браузера
        // Сбрасываем состояние перед редиректом
        setIsLoading(false);
        window.location.href = auth_url;
      }
    } catch (error: any) {
      console.error('❌ Google OAuth error:', error);
      const errorMessage = error.message || 'Не удалось инициировать вход через Google';
      onError?.(errorMessage);
      setIsLoading(false);
    }
  };

  return (
    <button 
      className="google-signin-button" 
      onClick={handleClick}
      disabled={isLoading}
    >
      {/* Google Logo SVG */}
      <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
      
      <span className="google-button-text">
        {isLoading 
          ? 'Загрузка...' 
          : mode === 'signin' 
            ? 'Войти через Google' 
            : 'Привязать Google аккаунт'
        }
      </span>
    </button>
  );
};

